import React from 'react'

import T from 'components/FormattedMessage'
import FriendListItem from 'components/FriendListItem'
import withUserLayer, { UserLayerProps } from 'components/UserLayer/withUserLayer'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'

import { IUser } from 'protos'

interface Props extends UserLayerProps {
  requests: Array<IUser>
  friends: Array<IUser>
  onChallenge: (userId: string) => any // tslint:disable-line:no-any
}

const MyFriends = withUserLayer<Props>(({ requests, friends, onChallenge, openUserLayer }) => (
  <List>
    {requests.length > 0 && (
      <ListItem divider>
        <Typography variant="caption" color="textSecondary">
          <T id="friends_section_requests" />
        </Typography>
      </ListItem>
    )}
    {requests.map((user, i) => (
      <FriendListItem
        key={i}
        onClick={() => { openUserLayer(user.userId!) }}
        friend={user}
      />
    ))}
    {friends.length > 0 && (
      <ListItem divider>
        <Typography variant="caption" color="textSecondary">
          <T id="friends_section_friends" />
        </Typography>
      </ListItem>
    )}
    {friends.map((user, i) => (
      <FriendListItem
        key={i}
        onClick={() => { openUserLayer(user.userId!) }}
        onChallengeClick={() => { onChallenge(user.userId!) }}
        friend={user}
      />
    ))}
  </List>
))

export default MyFriends
